<template>
    <p class="field-title">{{ label }}
        <QuestionBadge :publishGateEnabled="publishGateEnabled" :required="!!(item && item.required)" />
    </p>
    <MultiSelect :modelValue="selectedValue" @update:modelValue="handleInput" :options="options" optionLabel="name"
        :placeholder="placeholder" display="chip" :disabled="disableEdit"
        :selectionLimit="maxSelections || null">
        <template #chip="slotProps">
            <span>
                {{ slotProps.value.name }}<span v-if="slotProps.value.deprecated"> (Deprecated)</span>
            </span>
        </template>
        <template #option="slotProps">
            <span>
                {{ slotProps.option.name }}<span v-if="slotProps.option.deprecated"> (Deprecated)</span>
            </span>
        </template>
    </MultiSelect>
    <p v-if="maxSelections" class="selection-counter">
        {{ currentCount }} of {{ maxSelections }} selected
    </p>
    <p v-if="v$.selectedValue.$error" class="error-msg">{{ error_message }}</p>
</template>

<script>
import { ref, watch, computed } from 'vue';
import MultiSelect from 'primevue/multiselect';
import { useVuelidate } from '@vuelidate/core';
import { minLength, required } from '@vuelidate/validators';
import QuestionBadge from './QuestionBadge.vue';

export default {
    name: 'MultiSelectDropdownComponent',
    components: {
        MultiSelect,
        QuestionBadge,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        modelValue: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: '',
        },
        validation_rules: {
            type: Object,
            default: () => ({}),
        },
        error_message: {
            type: String,
        },
        options: {
            type: Array,
            default: () => [],
        },
        disableEdit: {
            type: Boolean,
            required: true,
        },
        item: {
            type: Object,
            default: () => ({}),
        },
        publishGateEnabled: {
            type: Boolean,
            default: false,
        },
        maxSelections: {
            type: Number,
            default: null,
        },
    },
    setup(props, { emit }) {
        const selectedValue = ref(props.modelValue);

        const rules = computed(() => {
            const validationRules = {};
            if (props.validation_rules.minLength) {
                validationRules.minLength = minLength(props.validation_rules.minLength);
                //validationRules.required = required;
            }
            return {
                selectedValue: validationRules,
            };
        });

        const v$ = useVuelidate(rules, { selectedValue });

        // Live count of chips driving the "N of M selected" counter.
        // Defensive against modelValue being null / object / single value
        // (older answer shapes) instead of an array.
        const currentCount = computed(() =>
            Array.isArray(selectedValue.value) ? selectedValue.value.length : 0
        );

        watch(
            () => props.modelValue,
            (newVal) => {
                selectedValue.value = newVal;
                v$.value.$touch();
                if (!v$.value.selectedValue.$error) {
                    emit('isValid', true);
                } else {
                    emit('isValid', false);
                }
            }
        );

        const handleInput = (newValue) => {
            emit('update:modelValue', newValue);
            selectedValue.value = newValue;
            v$.value.$touch();
            if (!v$.value.selectedValue.$error) {
                emit('isValid', true);
            } else {
                emit('isValid', false);
            }
        };

        return { selectedValue, v$, handleInput, currentCount };
    },
};
</script>

<style scoped>
.selection-counter {
    margin: 0.35rem 0 0;
    font-size: 0.8rem;
    font-style: italic;
    color: #64748b;
}
</style>
